import { StacksMainnet } from '@stacks/network';

const STX20_TEST_URL = 'https://api.stx20.com/api/v1/';
const STX20_MAIN_URL = 'https://api.stx20.com/api/v1/';
const MARKETPLACE_TEST_URL = 'https://api-marketplace.stx20.com/api/v1/';
const MARKETPLACE_MAIN_URL = 'https://api-marketplace.stx20.com/api/v1/';

const stx20ApiUrl = (network?: string) => (network === 'mainnet' ? STX20_MAIN_URL : STX20_TEST_URL);
const marketPlaceApiUrl = (network?: string) =>
  network === 'mainnet' ? MARKETPLACE_MAIN_URL : MARKETPLACE_TEST_URL;

export const getBalanceAddress = async (address: string, network: string) => {
  return fetch(`${stx20ApiUrl(network)}balance/${address}`)
    .then((res) => res.json())
    .then((r) => {
      if (r.error) {
        return null;
      }

      return r;
    });
};

export const getDomainsByAddress = async (
  address: string,
  page: number,
  limit: number,
  network: string
) => {
  return fetch(`${stx20ApiUrl(network)}domain?address=${address}&page=${page}&limit=${limit}`)
    .then((res) => res.json())
    .then((r) => {
      if (!r.success) {
        return null;
      }

      return r;
    });
};

export const getStxMapByAddress = async (
  address: string,
  page: number,
  limit: number,
  network: string
) => {
  return fetch(`${stx20ApiUrl(network)}stxmap?address=${address}&page=${page}&limit=${limit}`)
    .then((res) => res.json())
    .then((r) => {
      if (!r.success) {
        return null;
      }

      return r;
    });
};

export const getFloorPriceInfo = async (ticker: string, network: string) => {
  return fetch(`${marketPlaceApiUrl(network)}sell-requests/floor-price/${ticker}`)
    .then((res) => res.json())
    .then((r) => {
      if (!r.success) {
        return null;
      }

      return r;
    });
};

// export const formatSafeDate = (dateString?: string | Date) => {
//   if (!dateString) return '';
//   const date = new Date(dateString);

//   return date.toLocaleDateString('en-GB');
// };

export const displayFullAmount = (amount: number, decimals: number) =>
  amount.toFixed(decimals).replace(/\.?0+$/, '');

export const resolveBnsName = (
  // network: StacksNetwork,
  name: string
): Promise<string | null> => {
  return fetch(`${new StacksMainnet().coreApiUrl}/v1/names/${name}`)
    .then((r) => r.json())
    .then((r) => {
      if (r.error) {
        return null;
      }

      return r.address;
    });
};

export const resolveStxsName = (name: string, network: string): Promise<string | null> => {
  return fetch(`${stx20ApiUrl(network)}domain/${name}`)
    .then((r) => r.json())
    .then((r) => {
      if (!r.success) {
        return null;
      }

      return r.data.owner;
    });
};

// export const getBnsByAddress = (
//   // network: StacksNetwork,
//   name: string
// ): Promise<string | null> => {
//   return fetch(`${new StacksMainnet().coreApiUrl}/v1/addresses/stacks/${name}`)
//     .then((r) => r.json())
//     .then((r) => {
//       if (r.error) {
//         return null;
//       }

//       return r.names;
//     });
// };
